import Topics from '@/api/topics/topics.js';
import fileDownload from "js-file-download";
import router from "@/router";

const topics = new Topics();

const topicsModule = {
  namespaced: true,
  state: {
    items: [],
    item: null,
    lookups: [],
    subTopicsLookups: [],
    total: 0,
    load: false,
    loadItem:false,
  },
  getters: {
    items(state) {
      return state.items;
    },
    item(state) {
      return state.item;
    },
    load(state) {
      return state.load;
    },
    loadItem(state) {
      return state.loadItem;
    },
    total(state) {
      return state.total;
    },
    lookups(state) {
      return state.lookups;
    },
    subTopicsLookups(state) {
      return state.subTopicsLookups;
    },
  },
  mutations: {
    SET_ITEMS: (state, topics) => {
      state.items = topics;
    },
    SET_TOTAL_TOPICS: (state, total) => {
      state.total = total;
    },
    SET_ITEMS_LOAD: (state, load) => {
      state.load = load;
    },
    SET_ITEM: (state, school) => {
      state.item = school;
    },
    SET_LOAD_ITEM: (state, loadItem) => {
      state.loadItem = loadItem;
    },
    SET_LOOKUPS(state, lookups) {
      state.lookups = lookups;
    },
    SET_SUBTOPICS_LOOKUPS(state, lookups) {
      state.subTopicsLookups = lookups;
    },
  },
  actions: {
    list({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true);
        topics.list(payload).then(response => {
          commit('SET_ITEMS', response);
          commit('SET_ITEMS_LOAD', false);
          resolve();
        });
      });
    },
    put({ commit }, payload) {
      return new Promise((resolve, reject) => {
        topics
          .put(payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        topics
          .update(payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    lookups({ commit }) {
      return new Promise((resolve, reject) => {
        topics.lookups().then(response => {
          commit('SET_LOOKUPS', response.modules);
          resolve();
        });
      });
    },
    subTopicsLookups({ commit }) {
      return new Promise((resolve, reject) => {
        topics.subTopicsLookups().then(response => {
          commit('SET_SUBTOPICS_LOOKUPS', response.topic_types);
          resolve();
        });
      });
    },
    get({ commit , dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEM', null);
        
        commit('SET_LOAD_ITEM', true);
        topics.get(id)
          .then(response => {
            commit('SET_ITEM', response.topic[0]);

            commit('SET_LOAD_ITEM', false);
            dispatch('schools/updateBreadVale', response.topic[0].name, { root: true })
            resolve(response);
          })
          .catch(error => {
            reject(error);
            commit('SET_LOAD_ITEM', false);
          });
      });
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        topics
          .remove(id)
          .then(response => {
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    restore({ commit }, id) {
      return new Promise((resolve, reject) => {
        topics
          .restore(id)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    order({ commit }, payload) {
      return new Promise((resolve, reject) => {
        topics
          .order(payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    watched({ commit }, payload) {
      return new Promise((resolve, reject) => {
        topics
          .watched(payload)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    hardRemove({ commit }, id) {
      return new Promise((resolve, reject) => {
        topics
          .hardRemove(id)
          .then(response => {
            
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default topicsModule;
